import React from 'react';

import Lozenge from '@atlaskit/lozenge';

type QueryStatus = 'COMPLETED' | 'QUEUED' | 'FAILED' | 'IN_PROGRESS' | 'ABORTED';

interface QueryStatusLozengeProps {
	status: QueryStatus;
}

const getLozengeAppearance = (
	status: QueryStatus,
): 'success' | 'moved' | 'removed' | 'inprogress' | undefined => {
	switch (status) {
		case 'COMPLETED':
			return 'success';
		case 'QUEUED':
			return 'moved';
		case 'FAILED':
			return 'removed';
		case 'IN_PROGRESS':
			return 'inprogress';
		case 'ABORTED':
			return undefined;
		default:
			return undefined;
	}
};

const getStatusLabel = (status: QueryStatus): string => {
	switch (status) {
		case 'COMPLETED':
			return 'Completed';
		case 'QUEUED':
			return 'Queued';
		case 'FAILED':
			return 'Failed';
		case 'IN_PROGRESS':
			return 'In Progress';
		case 'ABORTED':
			return 'Aborted';
		default:
			return 'Unknown';
	}
};

export const QueryStatusLozenge = ({ status }: QueryStatusLozengeProps): React.JSX.Element => (
	<Lozenge appearance={getLozengeAppearance(status)} isBold>
		{getStatusLabel(status)}
	</Lozenge>
);
